import { BrowserHttpClient } from '@/services/Http/BrowserHttpClient';
import { AbstractStatesScheduler } from '@/services/UserActivity/AbstractStatesScheduler';
import { logger } from '@/utils/logger/logger';
import type { SavedSearch } from 'bnef';

export type ToolSavedSearch = {
    visibility: 'public' | 'private';
    savedSearches: SavedSearch[];
};
export class ToolSavedSearchScheduler extends AbstractStatesScheduler<ToolSavedSearch> {
    private static instance: ToolSavedSearchScheduler;

    private constructor() {
        super();
    }

    public static getInstance(): ToolSavedSearchScheduler {
        if (!ToolSavedSearchScheduler.instance) {
            ToolSavedSearchScheduler.instance = new ToolSavedSearchScheduler();
        }
        return ToolSavedSearchScheduler.instance;
    }

    protected async fetchStates(keys: string[]): Promise<string[]> {
        try {
            const response: Record<string, ToolSavedSearch | null> = await new BrowserHttpClient().post({
                path: '/tools/saved_searches',
                body: { keys },
            });
            if (response) {
                Object.entries(response).forEach(([key, state]) => {
                    this.states.set(key, state);
                    this.notifySubscribers(key, state);
                });
            }
            return [];
        } catch (error) {
            logger.error('Failed to fetch saved states:', error);
            return keys;
        }
    }

    protected getChangedEventName(): null {
        return null;
    }
}
